<flex-select #flexSelector [placeholder]="placeholder" [formControl]="flexSelect" [itemList]="optionList|async"
  [itemTemplate]="itemTemplate" [options]="flexSelectOptions" [multiple]="false" (selectionChange)="onSelectionChange($event)">
  <ng-template #itemTemplate let-item="item" let-isTruncated="truncate">
    <span country-flag *ngIf="item.country_code" [countryCode2]="item.country_code"></span>
    <span [matTooltip]="(item.number | displayPhoneNumber) + (item.name ? ' (' + item.name +')' : '')">{{ item.number | displayPhoneNumber }} <i *ngIf="item.name">({{ isTruncated ? (item.name | truncate) : item.name }})</i></span>
  </ng-template>
</flex-select>
